export class HealthGoal {
  id: number
  name?: string
  key?: string
  indicators: HealthIndicator[] = []

  constructor (attributes?) {
    Object.assign(this, attributes)
  }

  getProgress () {
    let sum = this.indicators.reduce(function (total, current) {
      return total + (current.getProgress() || 0)
    }, 0)
    const progress = +parseFloat((sum / this.indicators.length || 0).toString()).toFixed(1)
    return progress > 100 ? 100 : progress
  }

  get isTemplateGoal () {
    return !this.name && this.key
  }
}

export class HealthIndicator {
  id: number
  type: HealthIndicatorType
  target: number // expected value; e.g. target can be 23 MET
  sourceId: number // exercise tag id or activity id corresponding (based on sourceType)
  sourceType: HealthIndicatorSourceType
  value: number

  constructor (attributes?) {
    Object.assign(this, attributes)
  }

  getProgress () {
    const progress = +parseFloat((100 * this.value / this.target).toString()).toFixed(1)
    return progress > 100 ? 100 : progress
  }
}

export enum HealthIndicatorType {
  MET = 'met',
  PIX_SCORE = 'pix_score',
  EXERCISE_TAG_PERCENTAGE = 'exercise_tag_percentage',
  HOME_WORKOUT_DURATION = 'home_workout_duration',
  HOME_WORKOUT_FREQUENCY = 'home_workout_frequency',
  STATION_WORKOUT_DURATION = 'station_workout_duration',
  STATION_WORKOUT_FREQUENCY = 'station_workout_frequency',
  ACTIVITY_DURATION = 'activity_duration',
  ACTIVITY_FREQUENCY = 'activity_frequency'
}

export enum HealthIndicatorSourceType {
  ACTIVITY = 'Activity',
  EXERCISETAG = 'ExerciseTag'
}
